import('./bootstrap');

// Empty export makes this file a module.
// This is required for dynamic import to work.
export {};
